import { takeLatest, takeLeading } from "redux-saga/effects";

import { actionTypes } from "../actions";
import {
  deleteUserPassengerSaga,
  updateUserPassengerSaga,
  fetchUserPassengersSaga,
} from "./user-passenger";
import {
  deletePaymentMethodSaga,
  fetchPaymentMethodSaga,
  listPaymentMethodsSaga,
  verifyPaymentMethodSaga,
} from "./payment-method";
import {
  scheduleVacationRentalPriceQuoteSaga,
  pollVacationRentalsPriceQuoteSaga,
  scheduleVacationRentalsBookSaga,
  pollVacationRentalsConfirmationDetailsSaga,
  addMainGuestSaga,
} from "./vacation-rental-book";
import { fetchApplicableTravelWalletItemsSaga } from "./travel-wallet/fetchApplicableTravelWalletItemsSaga";
import { fetchProductToEarnSaga } from "./rewards/fetchProductToEarnSaga";
import { fetchAllEarnForProductSaga } from "./rewards/fetchAllEarnForProductSaga";
import { fetchCorpUserPassengersSaga } from "./user-passenger/capone-corporate/fetchCorpUserPassengersSaga";
import { cancelOnRedoSearch } from "./cancelOnRedoSearch";

export function* watchUpdateUserPassenger() {
  yield takeLeading(actionTypes.UPDATE_USER_PASSENGER, updateUserPassengerSaga);
}

export function* watchDeletePassengerSaga() {
  yield takeLeading(actionTypes.DELETE_USER_PASSENGER, deleteUserPassengerSaga);
}

export function* watchFetchUserPassengers() {
  yield takeLeading(actionTypes.FETCH_USER_PASSENGERS, fetchUserPassengersSaga);
}

export function* watchDeletePaymentMethodSaga() {
  yield takeLeading(actionTypes.DELETE_PAYMENT_METHOD, deletePaymentMethodSaga);
}

export function* watchFetchPaymentMethodSaga() {
  yield takeLeading(actionTypes.FETCH_PAYMENT_METHOD, fetchPaymentMethodSaga);
}

export function* watchListPaymentMethodsSaga() {
  yield takeLeading(actionTypes.LIST_PAYMENT_METHODS, listPaymentMethodsSaga);
}

export function* watchVerifyPaymentMethodSaga() {
  yield takeLeading(actionTypes.VERIFY_PAYMENT_METHOD, verifyPaymentMethodSaga);
}

export function* watchProductToEarnSaga() {
  yield takeLeading(
    actionTypes.FETCH_PRODUCT_TO_EARN,
    cancelOnRedoSearch(fetchProductToEarnSaga)
  );
}

export function* watchFetchAllEarnForProductSaga() {
  yield takeLeading(
    actionTypes.FETCH_ALL_EARN_FOR_PRODUCT,
    cancelOnRedoSearch(fetchAllEarnForProductSaga)
  );
}

export function* watchFetchApplicableTravelWalletItemsSaga() {
  yield takeLeading(
    actionTypes.FETCH_APPLICABLE_TRAVEL_WALLET_ITEMS,
    cancelOnRedoSearch(fetchApplicableTravelWalletItemsSaga)
  );
}

export function* watchScheduleVacationRentalPriceQuoteSaga() {
  yield takeLeading(
    actionTypes.SCHEDULE_VACATION_RENTAL_PRICE_QUOTE,
    cancelOnRedoSearch(scheduleVacationRentalPriceQuoteSaga)
  );
}

export function* watchPollVacationRentalsPriceQuoteSaga() {
  yield takeLeading(
    actionTypes.POLL_VACATION_RENTALS_PRICE_QUOTE,
    cancelOnRedoSearch(pollVacationRentalsPriceQuoteSaga)
  );
}

export function* watchAddMainGuestSaga() {
  // takeLatest, not takeLeading: the main guest is last-write-wins. A traveler or
  // email change while a call is in flight must supersede it, not be dropped.
  yield takeLatest(
    actionTypes.ADD_MAIN_GUEST,
    cancelOnRedoSearch(addMainGuestSaga)
  );
}

export function* watchScheduleVacationRentalsBookSaga() {
  yield takeLeading(
    actionTypes.SCHEDULE_VACATION_RENTALS_BOOK,
    scheduleVacationRentalsBookSaga
  );
}

export function* watchPollVacationRentalsConfirmationDetailsSaga() {
  yield takeLeading(
    actionTypes.POLL_VACATION_RENTALS_CONFIRMATION_DETAILS,
    pollVacationRentalsConfirmationDetailsSaga
  );
}

export function* watchFetchCorpUserPassengers() {
  yield takeLeading(
    actionTypes.FETCH_CORP_USER_PASSENGERS,
    fetchCorpUserPassengersSaga
  );
}
